import { motion } from "framer-motion";
import {
  Handshake,
  Globe,
  MagnifyingGlass,
  TrendUp,
  MapPinLine,
  Network,
} from "@phosphor-icons/react";

const services = [
  {
    icon: Handshake,
    title: "Commercial Brokerage",
    desc: "Connecting buyers, sellers, manufacturers and investors through trusted business relationships and strategic negotiations.",
  },
  {
    icon: Globe,
    title: "International Trade Facilitation",
    desc: "Supporting import and export operations by connecting businesses with qualified suppliers and buyers worldwide.",
  },
  {
    icon: MagnifyingGlass,
    title: "Supplier & Partner Sourcing",
    desc: "Identifying reliable manufacturers, distributors and strategic partners based on your specific requirements.",
  },
  {
    icon: TrendUp,
    title: "Business Development",
    desc: "Helping businesses discover new opportunities and expand into regional and international markets.",
  },
  {
    icon: MapPinLine,
    title: "Market Entry Support",
    desc: "Providing guidance and strategic support for companies entering new markets with confidence.",
  },
  {
    icon: Network,
    title: "Strategic Networking",
    desc: "Leveraging our extensive network to create valuable commercial opportunities for our clients.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-divider" />
            <span className="overline">What We Do</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-altin-ink tracking-tight">
            Services that move{" "}
            <span className="italic text-altin-gold">business forward</span>.
          </h2>
          <p className="mt-6 text-lg text-altin-muted font-light max-w-2xl leading-relaxed">
            From initial introduction to final agreement, we facilitate every
            stage of cross-border commercial relationships.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-altin-border border border-altin-border">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.55, delay: i * 0.06 }}
                className="group bg-white p-10 transition-all duration-300 hover:bg-altin-bg relative"
              >
                <div className="w-12 h-12 grid place-items-center bg-altin-surfaceAlt text-altin-gold mb-8 transition-colors duration-300 group-hover:bg-altin-ink group-hover:text-altin-gold">
                  <Icon size={26} weight="light" />
                </div>
                <div className="text-xs uppercase tracking-[0.22em] text-altin-muted mb-3">
                  0{i + 1}
                </div>
                <h3 className="font-serif-display text-2xl text-altin-ink mb-4 tracking-tight">
                  {s.title}
                </h3>
                <p className="text-altin-muted leading-relaxed">{s.desc}</p>
                <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-altin-gold transition-all duration-500 group-hover:w-full" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
